<template>
  <SoDialog
    v-model="value"
    :loading="isLoading"
    width="600"
    @on-close="$emit('closeModal')"
  >
    <template v-if="!isLoading && billRequest">
      <div class="d-flex align-center justify-space-between mb-5">
        <h4>Bill Request: {{ billRequest.id }}</h4>
        <SoStatus :status="new Status('critical', 'Failed')" />
      </div>

      <p class="mb-5">
        There is a failed bill on this account which means there is at least 1
        month without any bills.
      </p>

      <SoWidget>
        <p class="mb-3"><strong>Reason 6</strong></p>
        <p>
          The billing team will automatically investigate and process the bills
          within 2-4 months.
        </p>
        <p>There is no need to escalate this.</p>

        <SoButton
          title="Read more"
          type="link"
          href="https://home.so.energy/posts/2119762-failed-bills-bill-errors-step-by-step"
          class="mt-3"
        />
      </SoWidget>

      <dl class="mt-5 dl dl--aligned">
        <dt>Created at</dt>
        <dd>{{ formatDate(billRequest.taskCreatedDttm) }}</dd>
        <dt>Type</dt>
        <dd>{{ billRequest.typeCode }}</dd>
        <dt>Server message</dt>
      </dl>
      <pre class="text-wrap">{{ billRequest.serverMessage }}</pre>
    </template>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import { formatDate } from "@/helpers/dateHelper"
  import SoDialog from "@/components/SoDialog.vue"
  import SoStatus from "@/components/SoStatus.vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"
  import { Status } from "@/types/Status"
  import SoWidget from "@/components/SoWidget.vue"
  import SoButton from "@/components/formControls/SoButton.vue"

  export default defineComponent({
    components: {
      SoDialog,
      SoStatus,
      SoWidget,
      SoButton,
    },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
        required: true,
      },
      billRequestId: {
        type: Number,
        default: null,
      },
    },
    emits: ["update:modelValue", "closeModal"],
    data() {
      return {
        billRequests: useCurrentAccountStore().billRequest,
        formatDate,
        Status,
      }
    },
    computed: {
      value: {
        get() {
          return this.modelValue
        },
        set(value: boolean) {
          this.$emit("update:modelValue", value)
        },
      },
      billRequest() {
        return this.billRequests.data.find(
          (billRequest) => billRequest.id === this.billRequestId,
        )
      },
      isLoading() {
        return this.billRequests.isFetching
      },
    },
  })
</script>
